<template>
  <settings-section
    :title="$t('INBOX_MGMT.FACEBOOK_REAUTHORIZE.TITLE')"
    :sub-title="$t('INBOX_MGMT.FACEBOOK_REAUTHORIZE.SUBTITLE')"
  >
    <a class="fb--login" href="#" @click.prevent="tryFBlogin">
      <img
        src="~dashboard/assets/images/channels/facebook_login.png"
        alt="Facebook-logo"
      />
    </a>
  </settings-section>
</template>

<script>
import SettingsSection from '../../../../../components/SettingsSection';
import alertMixin from 'shared/mixins/alertMixin';
import { ensureFacebookSdk } from 'dashboard/helper/facebookSdk';

export default {
  components: {
    SettingsSection,
  },
  mixins: [alertMixin],
  props: {
    inboxId: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    ensureFacebookSdk({
      appId: window.chatwootConfig.fbAppId,
      version: window.chatwootConfig.fbApiVersion,
      status: true,
    }).catch(() => {});
  },

  methods: {
    async tryFBlogin() {
      try {
        const FB = await ensureFacebookSdk({
          appId: window.chatwootConfig.fbAppId,
          version: window.chatwootConfig.fbApiVersion,
          status: true,
        });

        FB.login(
          response => {
            if (response.status === 'connected') {
              this.reauthorizeFBPage(response.authResponse.accessToken);
            } else if (response.status === 'not_authorized') {
              // The person is logged into Facebook, but not your app.
              this.showAlert(this.$t('INBOX_MGMT.DETAILS.ERROR_FB_AUTH'));
            } else {
              // The person is not logged into Facebook, so we're not sure if
              // they are logged into this app or not.
              this.showAlert(this.$t('INBOX_MGMT.DETAILS.ERROR_FB_AUTH'));
            }
          },
          {
            scope:
              'pages_manage_metadata,pages_messaging,instagram_basic,pages_show_list,pages_read_engagement,instagram_manage_messages,business_management',
            auth_type: 'reauthorize',
          }
        );
      } catch (error) {
        this.showAlert(this.$t('INBOX_MGMT.DETAILS.ERROR_FB_AUTH'));
      }
    },
    async reauthorizeFBPage(omniauthToken) {
      try {
        await this.$store.dispatch('inboxes/reauthorizeFacebookPage', {
          omniauthToken,
          inboxId: this.inboxId,
        });
        this.showAlert(
          this.$t('INBOX_MGMT.FACEBOOK_REAUTHORIZE.MESSAGE_SUCCESS')
        );
      } catch (error) {
        this.showAlert(
          this.$t('INBOX_MGMT.FACEBOOK_REAUTHORIZE.MESSAGE_ERROR')
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/variables';

.fb--login {
  img {
    max-width: 240px;
    padding: $space-normal 0;
  }
}
</style>
